import { Link } from "react-router-dom";
import type { Post } from "@/types/content";

export default function TrendingList({ items }: { items: Post[] }) {
  return (
    <section aria-labelledby="trending-title" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.15fr] lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-fire-fill"></i>
              </span>
              实时榜单
            </span>
            <h2
              id="trending-title"
              className="mt-3 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-[40px]"
            >
              今日热搜榜
            </h2>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              综合点赞、评论与转发速度实时排序，每小时刷新一次。榜单靠前的话题通常正在多个学校的讨论区同时发酵，点进去就能看到完整脉络。
            </p>
            <Link
              to="/topics"
              className="mt-7 inline-flex items-center gap-2 rounded-md bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              查看全部讨论
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <ol className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {items.map((post, index) => (
              <li key={post.id}>
                <Link
                  to={`/post/${post.id}`}
                  className="flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:gap-5 md:px-5"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                      index < 3
                        ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-heading text-sm font-bold text-foreground-950 md:text-[15px]">
                      {post.title}
                    </span>
                    <span className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-map-pin-2-line"></i>
                        </span>
                        {post.school}
                      </span>
                      <span className="flex items-center gap-1 text-primary-600">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-thumb-up-line"></i>
                        </span>
                        {post.likes}
                      </span>
                    </span>
                  </span>
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400">
                    <i className="ri-arrow-right-up-line text-lg"></i>
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}